exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".invoice-row .el-col[data-v-384063d8]{line-height:30px;text-align:center}", "", {"version":3,"sources":["/workspace/src/views/payment-manager-new/components/PaymentWriteOffReview.vue"],"names":[],"mappings":"AACA,sCAAsC,iBAAiB,iBAAiB,CACvE","file":"PaymentWriteOffReview.vue","sourcesContent":["\n.invoice-row .el-col[data-v-384063d8]{line-height:30px;text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-384063d8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/payment-manager-new/components/PaymentWriteOffReview.vue
// module id = 4979
// module chunks = 8